// extracted by mini-css-extract-plugin
module.exports = {"container":"orderStatusBadge_container__3z453","prueba":"orderStatusBadge_prueba__uI1dp"};